module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_08-7b33d6c99b50cd31394e6f3132e69ee7.png";